module.exports = __webpack_public_path__ + "img/79.335c6351.svg";